import { motion } from "framer-motion";
import { IS_EXPORT } from "@/lib/exportMode";

// Subtle cinematic reveal — restrained, premium, editorial.
// In export/PDF mode we bypass the scroll-triggered animation entirely so
// every section renders fully visible (otherwise Framer Motion's
// `whileInView` keeps content at opacity:0 in headless print rendering).
export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  if (IS_EXPORT) return <div className={className}>{children}</div>;
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const RevealLine = ({ delay = 0, className = "" }) => {
  if (IS_EXPORT)
    return <div className={`h-px bg-gold/40 ${className}`} />;
  return (
    <motion.div
      initial={{ scaleX: 0, opacity: 0 }}
      whileInView={{ scaleX: 1, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.4, delay, ease: [0.16, 1, 0.3, 1] }}
      style={{ transformOrigin: "left" }}
      className={`h-px bg-gold/40 ${className}`}
    />
  );
};
